module.exports = __webpack_public_path__ + "static/time-ef1fa67dd5ae18b249015262b64b7d32.svg";